import React from 'react'

const UserRegion = ({ Region, setRegion, Phase, setPhase }) => {

    const handlePhaseChange = (e) => {
        setPhase(e.target.value);
    }
  return (
    <>
      <div> {/* Start */}
          <ul className="mt-2 flex flex-wrap -m-1">
              <li className="m-1">
                  <button className={"inline-flex items-center justify-center text-sm font-poppins font-medium leading-5 rounded-full px-3 py-1 border border-transparent shadow-sm duration-150 ease-in-out " +
                      (Region === 1
                      ? "bg-[#081a51] text-white" : " bg-white text-slate-500")
                  } onClick={e => {
                      e.preventDefault();
                      setRegion(1);
                  }} >All</button>
              </li>
              <li className="m-1">
                  <button className={"inline-flex items-center justify-center text-sm font-poppins font-medium leading-5 rounded-full px-3 py-1 border border-transparent shadow-sm duration-150 ease-in-out " +
                      (Region === 2
                          ? "bg-[#081a51] text-white"
                          : " bg-white text-slate-500")
                  } onClick={e => {
                      e.preventDefault();
                      setRegion(2);
                  }}>Pakistan</button>
              </li>
              <li className="m-1">
                  <button className={"inline-flex items-center justify-center text-sm font-poppins font-medium leading-5 rounded-full px-3 py-1 border border-transparent shadow-sm duration-150 ease-in-out " +
                      (Region === 3
                          ? "bg-[#081a51] text-white"
                          : " bg-white text-slate-500")
                  } onClick={e => {
                      e.preventDefault();
                      setRegion(3);
                  }}>Bangladesh</button>
              </li>
          </ul>
          {/* End */}</div>
          <div>
                      {/* <label className="block text-sm font-poppins font-medium my-1" htmlFor="Site Status"> Program Phase <span className="text-purple-500">*</span></label> */}
                      <select id="siteStatus" name='siteStatus' onChange={(e) => {
        setPhase(e.target.value);
    }} defaultValue={Phase} class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                      <option value="" disabled >Select Phase</option>
                      <option value="p3">Phase 3</option>
                      <option value="p4">Phase 4</option>
                    </select>
                  </div>
          </>
  )
}

export default UserRegion